import { createAsyncThunk } from '@reduxjs/toolkit'
import { searchPatientsByName } from '@services/api/patient.api'

export const fetchPatientsByName = createAsyncThunk(
  'api/patient/fetch/name',
  async (name: string, { rejectWithValue }) => {
    try {
      const response = await searchPatientsByName(name)
      if (response.statusCode !== 200) {
        return rejectWithValue(response.message)
      }
      return response.data.patients
    } catch (error: any) {
      return rejectWithValue(error.message || 'Failed to fetch patients')
    }
  },
)
